import { createElement } from "react";
import './index.scss';
const ColorfulSteps = function ColorfulSteps({ className, current = 1, status = 'normal', direction = 'horizontal', source, progressDot = true, }) {
    const data = source;
    const lastIndex = source.length - 1;
    const isDot = progressDot;
    const getClassName = (index, name) => {
        if (current > index) {
            return `step-${name}-finish`;
        }
        if (current === index) {
            if (status === 'error' && name === 'title') {
                return `step-${name}-fail`;
            }
            return `step-${name}-current`;
        }
        return `step-${name}-waiting`;
    };
    const getProgressDot = () => {
        return data.map((item, index) => (createElement("div", { className: "step-item" },
            index < lastIndex ? (createElement("div", { className: index < current ? 'finish-tail' : 'tail' })) : null,
            index <= current ? (createElement("div", { className: `${current === index && status === 'error' ? 'current-point fail-point' : 'finish-point'}` })) : (createElement("div", { className: 'waiting-point' })),
            createElement("div", { className: `${direction === 'vertical' ? 'vertical' : ''}` },
                createElement("div", { className: getClassName(index, 'title') }, item?.title || ''),
                item?.description ? (createElement("div", { className: getClassName(index, 'desc') }, item?.description || '')) : null))));
    };
    const getPointCon = (current, index) => {
        if (current === index && status === 'error') {
            return createElement("span", { class: "point-num" },
                createElement("i", { className: "icon-times" }));
        }
        if (current === index) {
            return createElement("span", { class: "point-num" }, index + 1);
        }
        if (current !== index) {
            return createElement("span", { class: "point-num" },
                createElement("i", { className: "icon-angle-down" }));
        }
    };
    const getProgressNum = () => {
        return data.map((item, index) => (createElement("div", { className: "step-item num" },
            index < lastIndex ? (createElement("div", { className: index < current ? 'finish-tail' : 'tail' })) : null,
            index <= current ? (createElement("div", { className: `${current === index && status === 'error' ? 'current-point fail-point' : 'finish-point'}` }, getPointCon(current, index))) : (createElement("div", { className: 'waiting-point' },
                createElement("span", { class: "point-num" }, index + 1))),
            createElement("div", { className: `step-con ${direction === 'vertical' ? 'vertical' : ''}` },
                createElement("div", { className: "step-title " + getClassName(index, 'title') }, item?.title || ''),
                item?.description ? (createElement("div", { className: getClassName(index, 'desc') }, item?.description || '')) : null))));
    };
    return (createElement("div", { className: `au-steps ${direction} ${className || ''}` }, isDot ? getProgressDot() : getProgressNum()));
};
ColorfulSteps.displayName = 'ColorfulSteps';
export default ColorfulSteps;
